import { forwardRef } from "react";

import { Loading } from "~/components/common/loading";

import { ArchiveWallContainerClass } from "./consts";
import { Container, LoadingContainer, Wrapper } from "./styles";

type Props = {
  className?: string;
  isShowInlinePaywall?: boolean;
};

/**
 * This component is for showing inline paywall, ArchiveWallContainerClass is the class config in piano
 * It will replace the content in all element with class ArchiveWallContainerClass, so we need to remove the class once loaded the content
 * isShowPaywall will be undefined in the beginning and set the value (true / false) after piano executed
 */
export const ArticlePaywallContainer = forwardRef<HTMLDivElement, Props>(
  ({ className, isShowInlinePaywall }, reference) => (
    <Container $isShowPaywall={isShowInlinePaywall} className={className}>
      <LoadingContainer>
        <Loading />
      </LoadingContainer>
      <Wrapper
        className={isShowInlinePaywall === undefined ? ArchiveWallContainerClass : ""}
        ref={reference}
      />
    </Container>
  ),
);

ArticlePaywallContainer.displayName = "ArticlePaywallContainer";
